export const MASK = 'https://ketch.com/v1/obligations/mask/fixed'
export const HASH = 'https://ketch.com/v1/obligations/hash/md5'
export const DENY = 'https://ketch.com/v1/obligations/deny'
